// extracted by css-extract-rspack-plugin
export default {"loadingWrapper":"EQYEV"};